import type { MetadataScopesApiResponse, MetadataScopesResponse } from '@/types/metadata';

/**
 * The API omits entireCompany when it is unknown (not yet in analytics) or was not
 * requested; that distinction must survive into the store, so it is never defaulted here.
 */
export const transformMetadataScopesResponse = (
  response: MetadataScopesApiResponse
): MetadataScopesResponse => ({
  directReports: response.directReports ?? 0,
  allReports: response.allReports ?? 0,
  entireCompany: response.entireCompany ?? undefined,
  managesLeaders: response.managesLeaders ?? false,
});
